module.exports = __webpack_public_path__ + "img/ReSharperCPP_icon.aa1daf12.png";